import React from 'react';
import '../css/Calendly.css';

import { InlineWidget } from 'react-calendly';

import line from '../images/underline.png';

import decoration1 from '../images/decorations/01.png';
import decoration2 from '../images/decorations/02.png';
import { useSelector } from 'react-redux';

const Calendly = () => {
	const banner = useSelector((state) => state.banner.value.banner);
	const width = window.innerWidth <= 460 ? 150 : 60;

	const paddingTop = banner ? { paddingTop: width + 80 } : { paddingTop: 80 };

	return (
		<div className='Calendly' id='home' style={paddingTop}>
			<div className='calendly-container container padding'>
				<img src={decoration1} alt='Decoration' className='calendly-decoration-1' />
				<img src={decoration2} alt='Decoration' className='calendly-decoration-2' />

				<h1 className='calendly-title'>
					ÚNETE <br />
					<span>
						CHARLA INFORMATIVA
						<img src={line} alt='Underline' />
					</span>
				</h1>
				<p className='calendly-paragraph'>
					En <b>LIBEL ACADEMY</b> nos encantaría conversar contigo y resolver todas tus dudas e
					inquietudes para que puedas emprender este camino a ser profesional 3d. <br /> ¿No te
					sirven los horarios?{' '}
					<a
						href='https://api.whatsapp.com/send?phone=573228638257&text=Hola%2C%20Viviana%20%F0%9F%91%8B%20%C2%A1Me%20gustar%C3%ADa%20recibir%20asesor%C3%ADa'
						target='_blank'
						style={{ color: '#6000de' }}
					>
						escríbenos
					</a>{' '}
					y con gusto te coordinamos que se ajuste a tus tiempos
				</p>
				<InlineWidget
					url='https://calendly.com/libel/asesoria-general'
					styles={{
						height: '600px',
						width: window.innerWidth <= 460 ? 300 : 500,
						marginTop: 20,
						boxShadow: '0 0  5px 1px rgba(0,0,0,0.6)',
						borderRadius: '20px',
						overflow: 'hidden',
					}}
					pageSettings={{
						backgroundColor: 'ECEFF1',
						hideEventTypeDetails: true,
						hideLandingPageDetails: false,
						primaryColor: '6000de',
						textColor: '000000',
					}}
				/>
			</div>
		</div>
	);
};

export default Calendly;
